const NAMES: Record<string, Record<string, string>> = {
  "pt-BR": {
    en: "Brazilian Portuguese",
    "pt-BR": "português brasileiro",
    es: "portugués brasileño",
  },
  en: {
    en: "English",
    "pt-BR": "inglês",
    es: "inglés",
  },
  es: {
    en: "Spanish",
    "pt-BR": "espanhol",
    es: "español",
  },
};

export function languageNameForLocale(locale: string, inLocale: string = "en"): string {
  return NAMES[locale]?.[inLocale] ?? locale;
}

export function sttLanguageCode(locale: string): string {
  return locale.split("-")[0] ?? locale;
}
